// Lets the map's gate (account/MapGate.js) turn down a change before it reaches the store:
// new layers, a new place, or the area overview opening by itself. Kept free of map code,
// since the store is in the main bundle. With no gate set (any page but the map, or a
// subscriber) every action goes through.
let gate = null;

// gate(action, mapState) returns false to drop the action
export const setMapGate = (fn) => { gate = fn; };

export const mapGateMiddleware = (store) => (next) => (action) => {
    if (gate && action && typeof action.type === 'string' && action.type.startsWith('map/')
        && gate(action, store.getState().map) === false) return undefined;
    return next(action);
};

// The overview opened by the user's own click (its tab, the phone's button, the marker),
// which the gate lets through when it stops the overview opening by itself
export const byUser = (action) => ({...action, meta:{...(action.meta || {}), byUser:true}});
